import React, { useState } from 'react';
import { useShift } from '../../context/ShiftContext';
import { format, parseISO } from 'date-fns';
import { PlusIcon, CalendarIcon, TrashIcon, PencilIcon, CheckIcon, XIcon } from 'lucide-react';
const ManageHolidays = () => {
  const {
    holidays,
    addHoliday,
    updateHoliday,
    deleteHoliday
  } = useShift();
  const [name, setName] = useState('');
  const [date, setDate] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [editingId, setEditingId] = useState<number | null>(null);
  const [editName, setEditName] = useState('');
  const [editDate, setEditDate] = useState('');
  const handleAddHoliday = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    // Validation
    if (!name || !date) {
      setError('Both name and date are required');
      return;
    }
    if (holidays.some(h => h.date === date)) {
      setError('A holiday on this date already exists');
      return;
    }
    // Add holiday
    addHoliday({
      name,
      date
    });
    // Reset form
    setName('');
    setDate('');
    // Show success message
    setSuccessMessage('Holiday added successfully!');
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
  };
  const handleDeleteHoliday = (id: number) => {
    if (window.confirm('Are you sure you want to delete this holiday?')) {
      deleteHoliday(id);
    }
  };
  const startEditing = (holiday: {
    id: number;
    name: string;
    date: string;
  }) => {
    setEditingId(holiday.id);
    setEditName(holiday.name);
    setEditDate(holiday.date);
  };
  const cancelEditing = () => {
    setEditingId(null);
    setEditName('');
    setEditDate('');
  };
  const saveEditing = () => {
    if (!editingId) return;
    // Validation
    if (!editName || !editDate) {
      setError('Both name and date are required');
      return;
    }
    const existingHoliday = holidays.find(h => h.date === editDate && h.id !== editingId);
    if (existingHoliday) {
      setError('A holiday on this date already exists');
      return;
    }
    // Update holiday
    updateHoliday(editingId, {
      name: editName,
      date: editDate
    });
    // Reset form
    cancelEditing();
    // Show success message
    setSuccessMessage('Holiday updated successfully!');
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
  };
  return <div data-id="element-195">
      <h3 className="text-xl font-semibold mb-6 text-gray-700" data-id="element-196">
        Manage Holidays
      </h3>
      {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4" data-id="element-197">
          {error}
        </div>}
      {successMessage && <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4" data-id="element-198">
          {successMessage}
        </div>}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-199">
        <div className="md:col-span-2" data-id="element-200">
          <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-201">
            <ul className="divide-y divide-gray-200" data-id="element-202">
              {holidays.sort((a, b) => a.date.localeCompare(b.date)).map(holiday => <li key={holiday.id} data-id="element-203">
                    {editingId === holiday.id ? <div className="px-4 py-4 sm:px-6" data-id="element-204">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-205">
                          <div data-id="element-206">
                            <label htmlFor="editName" className="block text-sm font-medium text-gray-700" data-id="element-207">
                              Name
                            </label>
                            <input type="text" id="editName" value={editName} onChange={e => setEditName(e.target.value)} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-208" />
                          </div>
                          <div data-id="element-209">
                            <label htmlFor="editDate" className="block text-sm font-medium text-gray-700" data-id="element-210">
                              Date
                            </label>
                            <input type="date" id="editDate" value={editDate} onChange={e => setEditDate(e.target.value)} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-211" />
                          </div>
                        </div>
                        <div className="mt-4 flex justify-end space-x-3" data-id="element-212">
                          <button onClick={cancelEditing} className="inline-flex items-center px-3 py-1 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-213">
                            <XIcon size={16} className="mr-2" data-id="element-214" />
                            Cancel
                          </button>
                          <button onClick={saveEditing} className="inline-flex items-center px-3 py-1 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" style={{
                    backgroundColor: '#4772B0'
                  }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#EF5350'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#4772B0'} data-id="element-215">
                            <CheckIcon size={16} className="mr-2" data-id="element-216" />
                            Save
                          </button>
                        </div>
                      </div> : <div className="px-4 py-4 flex items-center justify-between sm:px-6" data-id="element-217">
                        <div data-id="element-218">
                          <h4 className="text-lg font-medium text-gray-900" data-id="element-219">
                            {holiday.name}
                          </h4>
                          <p className="text-sm text-gray-500" data-id="element-220">
                            {format(parseISO(holiday.date), 'MMMM d, yyyy')} (
                            {format(parseISO(holiday.date), 'EEEE')})
                          </p>
                        </div>
                        <div className="flex space-x-2" data-id="element-221">
                          <button onClick={() => startEditing(holiday)} className="text-blue-600 hover:text-blue-900" data-id="element-222">
                            <PencilIcon size={20} data-id="element-223" />
                          </button>
                          <button onClick={() => handleDeleteHoliday(holiday.id)} className="text-red-600 hover:text-red-900" data-id="element-224">
                            <TrashIcon size={20} data-id="element-225" />
                          </button>
                        </div>
                      </div>}
                  </li>)}
            </ul>
          </div>
        </div>
        <div data-id="element-226">
          <div className="bg-gray-50 p-4 rounded-md shadow-sm border border-gray-200" data-id="element-227">
            <h4 className="text-lg font-medium text-gray-900 mb-4" data-id="element-228">
              Add New Holiday
            </h4>
            <form onSubmit={handleAddHoliday} data-id="element-229">
              <div className="space-y-4" data-id="element-230">
                <div data-id="element-231">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-232">
                    Holiday Name
                  </label>
                  <input type="text" id="name" value={name} onChange={e => setName(e.target.value)} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" placeholder="e.g. New Year's Day" data-id="element-233" />
                </div>
                <div data-id="element-234">
                  <label htmlFor="date" className="block text-sm font-medium text-gray-700" data-id="element-235">
                    Date
                  </label>
                  <input type="date" id="date" value={date} onChange={e => setDate(e.target.value)} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-236" />
                </div>
                <div data-id="element-237">
                  <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" style={{
                  backgroundColor: '#4772B0'
                }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#EF5350'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#4772B0'} data-id="element-238">
                    <CalendarIcon size={16} className="mr-2" data-id="element-239" />
                    Add Holiday
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>;
};
export default ManageHolidays;